class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    button.addEventListener("click", (event) => {
      this.expandShowMore(event);
      this.classList.toggle("expanded");
      const nextElementToFocus = event.target
        .closest(".parent-display")
        .querySelector(".show-more-item");
      // if (
      //   nextElementToFocus &&
      //   !nextElementToFocus.classList.contains("hidden")
      // ) {
      //   nextElementToFocus.querySelector("input").focus();
      // }
    });
  }

  expandShowMore(event) {
    const parentDisplay = event.target
      .closest('[id^="Show-More-"]')
      .closest(".parent-display");
    const parentWrap = parentDisplay.querySelector(".parent-wrap");
    this.querySelectorAll(".label-text").forEach((element) =>
      element.classList.toggle("hidden")
    );
    parentDisplay.querySelectorAll(".show-more-item").forEach((item) => {
      if (item.hasAttribute("expanded")) {
        item.style.overflow = "hidden";
        item.style.height = "150px";
        item.removeAttribute("expanded");
      } else {
        item.style.overflow = "visible";
        item.style.height = "auto";
        item.setAttribute("expanded", "");
      }
    });
    if (!event.target.classList.contains("expanded")) {
      // scroll to top with smooth behavior using window.scrollTo
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
}

customElements.define("show-more-button", ShowMoreButton);
